var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$isErikoistuva())?_c('ArvioinnitErikoistuva'):(_vm.$isVastuuhenkilo())?_c('ArvioinnitVastuuhenkilo'):_c('ArvioinnitKouluttaja')}
var staticRenderFns = []

export { render, staticRenderFns }